export const initResume = (form = {}) => ({
    ...form,

    name: form?.name || null,
    profile: form?.profile || null,

    personalInformation: initPersonalInformation(form?.personalInformation),

    education: initEducation(form?.education),

    workExperience: initWorkExperience(form?.workExperience),

    languages: [...(form?.languages || [])].map(initLanguageItem),

    officeSkills: [...(form?.officeSkills || [])].map(initOfficeSkillItem),

    certifications: [...(form?.certifications || [])].map(initCertificationItem),

    coverLetter: {
        ...(form?.coverLetter || {}),
        subject: form?.coverLetter?.subject || null,
        content: form?.coverLetter?.content || null,
    },
});

export const initPersonalInformation = (form = {}) => ({
    ...(form || {}),

    name: form?.name || null,
    phone: form?.phone || null,
    email: form?.email || null,
    gender: form?.gender || null,
    bornAt: form?.bornAt?.toDate?.() || form?.bornAt || null,

    residence: {
        ...(form?.residence || {}),

        postcode: form?.residence?.postcode || null,
        address1: form?.residence?.address1 || null,
        address2: form?.residence?.address2 || null,
    },
});

export const initEducation = (form = {}) => {
    form = initEducationItem(form || {});
    delete form.tempId;

    return {
        ...form,
        otherEducations: (form?.otherEducations || []).map(initEducationItem),
    };
};

export const initEducationItem = (form = {}) => ({
    ...(form || {}),

    institutionType: form?.institutionType || null,
    institutionName: form?.institutionName || null,
    institutionDist: form?.institutionDist || null,
    attendingStatus: form?.attendingStatus || null,
    attendingEndsAt: form?.attendingEndsAt || null,
    attendingStartsAt: form?.attendingStartsAt || null,

    tempId: form?.tempId ?? `${Math.random().toString()}`.slice(2),
});

export const initWorkExperience = (item = {}) => {
    return {
        ...(item || {}),
        type: item?.type || null,
        span: {
            ...(item?.span || {}),
            years: item?.span?.years || null,
            months: item?.span?.months || null,
        },
        list: (item?.list || []).map(initWorkExperienceItem),
    };
};

export const initWorkExperienceItem = (form = {}) => {
    return {
        ...(form || {}),

        type: form?.type || null,
        companyName: form?.companyName || null,
        description: form?.description || null,

        duration: {
            ...(form?.duration || {}),
            startsAt: form?.duration?.startsAt?.toDate?.() || form?.duration?.startsAt || null,
            endsAt: form?.duration?.endsAt?.toDate?.() || form?.duration?.endsAt || null,
        },

        tempId: form?.tempId ?? `${Math.random().toString()}`.slice(2),
    };
};

export const initLanguageItem = (form = {}) => ({
    ...(form || {}),
    type: form?.type || null,
    name: form?.name || null,
    score: form?.score || 0,
    tempId: form?.tempId ?? `${Math.random().toString()}`.slice(2),
});

export const initOfficeSkillItem = (form = {}) => ({
    ...(form || {}),
    type: form?.type || null,
    name: form?.name || null,
    score: form?.score || 0,
    tempId: form?.tempId ?? `${Math.random().toString()}`.slice(2),
});

export const initCertificationItem = (form = {}) => ({
    ...(form || {}),
    name: form?.name || null,
    desc: form?.desc || null,
    issuer: form?.issuer || null,
    issuedAt: form?.issuedAt || null,
    tempId: form?.tempId ?? `${Math.random().toString()}`.slice(2),
});
